import config from '@/config/index';

function getMessagesByUid(uid) {
    return `${config.HOST_API}${config.BASE_API_PREFIX}/messages`;
}

export {
    getMessagesByUid,
};